module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fzg-about-pc"
  }, [_c('div', {
    staticClass: "fzg-banner"
  }, [_c('fzg-menu')], 1), _vm._v(" "), _c('div', {
    staticClass: "section fzg-about-intro"
  }, [_c('img', {
    staticClass: "eco-title",
    attrs: {
      "src": require("../../assets/img2/pc/about/fzg-about-title-intro.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "intro-title-line"
  }), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "intro-profile"
  }, [(false) ? _c('div', {
    staticClass: "pro-item-list"
  }, [_c('div', {
    staticClass: "pro-item"
  }), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _vm._l((1), function(i) {
    return _c('div', {
      staticClass: "pro-item"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(" 2022中国最具影响力新型投行 TOP 5 ")]), _vm._v(" "), _c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v("36氪")])])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pro-item-list swiper-container profileSwiper"
  }, [_c('div', {
    staticClass: "pro-item swiper-wrapper"
  }, _vm._l((_vm.profileData), function(item) {
    return _c('div', {
      staticClass: "swiper-slide pro-swiper-item"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.source))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "profile-arrow-line"
  }, [_c('div', {
    staticClass: "aa-left",
    on: {
      "click": function($event) {
        _vm.onClickLeftSwiper()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "aa-right",
    on: {
      "click": function($event) {
        _vm.onClickRightSwiper()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "section fzg-teams-g4"
  }, [_c('img', {
    staticClass: "team-title",
    attrs: {
      "src": require("../../assets/img2/pc/about/fzg-about-title-core-team.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "team-data"
  }, [_c('div', {
    staticClass: "person-item",
    on: {
      "click": function($event) {
        _vm.showPartner(0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "person-item",
    on: {
      "click": function($event) {
        _vm.showPartner(1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "person-item",
    on: {
      "click": function($event) {
        _vm.showPartner(2)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "person-item",
    on: {
      "click": function($event) {
        _vm.showPartner(3)
      }
    }
  })])]), _vm._v(" "), _vm._m(3, false, false), _vm._v(" "), _vm._m(4, false, false), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isShowPartnerModal) ? _c('fzg-about-partner-modal', {
    attrs: {
      "partner-index": _vm.partnerIndex
    },
    on: {
      "hide-modal": function($event) {
        _vm.isShowPartnerModal = false
      }
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-content"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/img2/pc/about/fzg-about-logo.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('p', [_vm._v("凡卓集团成立于2014年，依托独有的创投生态体系，扎根产业实体。面向高质量的科创城市、创业者、机构投资者、产业专家、行业从业者、科创巨头企业，提供财务顾问、直接投资、创业孵化、创投媒体、产业咨询、商机对接、创投培训、路演论坛、飞地运营等服务。 ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("凡卓集团的使命是“帮助创业者找人、找钱、找产业政策”，旗下包含小饭桌创服、小饭桌创投、凡卓资本三个板块，其中凡卓资本累计帮助近600家企业完成超800亿元融资，近两年内帮助数百个明星项目完成近300亿元融资。 ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pro-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("2022年度中国企业服务领域财务顾问 TOP 2")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("企名片")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pro-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(" 2022年度中国最佳财务顾问综合榜 TOP 4 ")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("企名片")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fzg-advantage"
  }, [_c('img', {
    staticClass: "title-business",
    attrs: {
      "src": require("../../assets/img2/pc/about/fzg-about-title-advantage.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "advantage-area"
  }, [_c('div', {
    staticClass: "bus-item"
  }, [_c('img', {
    staticClass: "bus-icon",
    attrs: {
      "src": require("../../assets/img2/pc/about/about-advantage-1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bus-title"
  }, [_vm._v("深耕案源")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("结构性覆盖产业关键节点"), _c('br'), _vm._v("批量导入、准确研判")]), _vm._v(" "), _c('div', {
    staticClass: "bus-content"
  }, [_c('b', [_vm._v(" 小饭桌新媒体：")]), _vm._v("创投圈最具影响力的小饭桌新媒体全力协助融资\n          "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('b', [_vm._v(" 媒体联盟：")]), _vm._v("与国内近百家党政媒体、财经媒体及科技行业垂直媒体保持紧密合作；与十余家业内专业的创投媒体形成合作矩阵\n          "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('b', [_vm._v("产业资金：")]), _vm._v("4000家活跃机构18000位产业投资人\n          "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('b', [_vm._v("产业资产：")]), _vm._v("世界、国内500强企业矩阵式合作关系，从集团到控股子公司深度协同\n          "), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "bus-item"
  }, [_c('div', {
    staticClass: "bus-title"
  }, [_vm._v("深入一线")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("一线地域布局 "), _c('br'), _vm._v(" 一线认知力、一线资源库 ")]), _vm._v(" "), _c('div', {
    staticClass: "bus-content"
  }, [_c('b', [_vm._v(" 资金注入：")]), _vm._v("协同政府引导基金及子基金，投资与当地产业链配套的优秀企业\n          "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('b', [_vm._v(" 政策支持：")]), _vm._v("帮助政府进行创投名片打造、投后管理及招商引资工作，熟知各地一手落地政策信息\n\n          "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('b', [_vm._v(" 产学一体：")]), _vm._v("战略合作多所顶级高校、科研院所\n\n          "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('b', [_vm._v(" 专家顾问：")]), _vm._v("创业营签约独角兽公司CEO、百余位专家院士入库\n          "), _c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('img', {
    staticClass: "bus-icon",
    attrs: {
      "src": require("../../assets/img2/pc/about/about-advantage-2.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bus-item"
  }, [_c('img', {
    staticClass: "bus-icon",
    attrs: {
      "src": require("../../assets/img2/pc/about/about-advantage-3.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bus-title"
  }, [_vm._v("深度闭环")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("夥伴共荣闭环"), _c('br'), _vm._v(" 企业内生与外延闭环、区域价值流转闭环")]), _vm._v(" "), _c('div', {
    staticClass: "bus-content"
  }, [_c('b', [_vm._v("长期陪伴的产业财务顾问：")]), _vm._v("从项目伊始到上市规划的长线服务，前瞻性思考、全局性谋划\n\n          "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('b', [_vm._v(" 企业业务发展战略咨询：")]), _vm._v(" 对接生产资料资源、业务增长的发展建议，引荐客户、匹配产业链上下游业务合作\n\n          "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('b', [_vm._v("产业升级：")]), _vm._v("深入到区与县一级的产业链中推动质量变革、效率变革、动力变革\n\n          "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('b', [_vm._v("项目落地：")]), _vm._v(" 运用投研力量与数据禀赋，精准对接项目与承载区域\n        ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section fzg-history"
  }, [_c('img', {
    staticClass: "eco-title",
    attrs: {
      "src": require("../../assets/img2/pc/about/fzg-about-title-history.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "eco-data"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ca8d58f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/FzgAboutPc.vue
// module id = 243
// module chunks = 0